<template>
	<div>
		<div>
		<!-- footer-cs-content -->
			<div class="footer-cs-center">
				<dl>
					<dt>NICE디앤비 대표전화 : <p>02-2122-2500</p></dt>
					<dd>고객센터 전화문의 : 평일 9:00~18:00 / 점심시간 12:00~13:00 (토, 일 및 법정 공휴일 휴무)</dd>
				</dl>
			</div>
			<!-- //footer-cs-content -->
			
			<!-- footer-content -->
			<div class="footer-content">
				<!-- family-cs-center -->
				<div class="family-cs-center">
					<dl onclick="link_2308();" title="새창으로 보기">
						<dt>공공기관 제출용 기업평가</dt>
						<dd>
							<p>02-2122-2308</p>
							www.nicers.co.kr
						</dd>
					</dl>
					<dl onclick="link_2550();" title="새창으로 보기">
						<dt>민간기업 제출용 기업평가</dt>
						<dd>
							<p>02-2122-2550</p>
							www.nicers.co.kr
						</dd>
					</dl>
					<dl onclick="link_2550();" title="새창으로 보기">
						<dt>ESG평가</dt>
						<dd>
							<p>02-2122-2337</p>
							www.nicers.co.kr
						</dd>
					</dl>
					<dl onclick="link_tcb();" title="새창으로 보기">
						<dt>기술신용평가(TCB)</dt>
						<dd>
							<p>02-2122-1300</p>
							www.gotcb.co.kr
						</dd>
					</dl>
					<dl onclick="link_global();" title="새창으로 보기">
						<dt>해외기업정보</dt>
						<dd>
							<p>02-2122-2515</p>
							global.nicednb.com
						</dd>
					</dl>
					<dl onclick="link_creport();" title="새창으로 보기">
						<dt>국내기업정보</dt>
						<dd>
							<p>02-2122-2536</p>
							www.creport.co.kr
						</dd>
					</dl>
					<dl onclick="link_consulting();">
						<dt>데이터가치평가/ 컨설팅</dt>
						<dd>
							<p>02-2122-2546</p>
						</dd>
					</dl>
					<dl onclick="link_kdata();">
						<dt>데이터 바우처</dt>
						<dd>
							<p>02-2122-2522</p>
							www.kdata.or.kr
						</dd>
					</dl>
				</div>
				<!-- //family-cs-center -->
				<!-- policy-link -->
				<div class="policy-link">
					<ul>
						<li><a href="/cs/cs-center03-pp.do"><b style="color: orange;">개인정보처리방침</b></a></li>
						<li><a href="/cs/cs-center03-coe.do">윤리강령</a></li>
						<li><a href="/cs/cs-center03-ci.do">신용정보활용체제공시</a></li>
						<li><a href="/file/cmp_grd.pdf" target="_blank">신용등급체계공시</a></li>
						<li><a href="/file/cmp_grd2.pdf" target="_blank">개인사업자 신용등급체계공시</a></li>
						<li><a href="/cs/cs-center04.do">공정거래자율준수</a></li>
						<li><a href="/cs/cs-center03-ec.do">이메일무단수집거부</a></li>
						<li><a href="/cs/cs-center05-1.do">전자민원센터</a></li>
						<li><a href="/site_map.do">사이트맵</a></li>
					</ul>
				</div>
				<!-- //policy-link -->
				<!-- ndb-info-wrap -->
				<div class="ndb-info mt40">
					<div class="ndb-info">
						<p style="font-size: 17px; margin-bottom: 5px;"><strong>&#12828;NICE디앤비</strong></p>
						<p><strong>주소 :</strong>(04535) 서울특별시 중구 소공로70, 포스트타워 B동 16층  &#12828;NICE디앤비</p>
							<p><strong>통신판매업신고 :</strong> 제2024-서울중구-1736호</p>
							<p><strong>사업자등록번호 :</strong> 107-86-24874</p>
							<p><strong>FAX :</strong> 02-2122-2543</p>
						<p><strong>COPYRIGHT &#169; 2019 NICE D&amp;B Co.,Ltd. ALL RIGHTS RESERVED.</strong></p>
					</div>
				</div>
				<!-- //ndb-info-wrap -->
				<!-- select-family-link -->
				<div class="select-family-link">
					<select id="family-link">
						<option>FAMILY SITE</option>
						<option value="http://www.nice.co.kr">NICE 홀딩스</option>
						<!-- <option value="http://www.nicednb.com">NICE D&#38;B</option> -->
						<option value="http://www.nicednr.co.kr">NICE D&amp;R</option>
						<option value="http://www.niceinfo.co.kr">NICE평가정보</option>
						<option value="http://www.nicerating.com">NICE신용평가</option>
						<option value="http://www.niceamc.co.kr">NICE신용정보</option>
						<option value="http://www.nicepni.co.kr">NICE피앤아이</option>
						<option value="http://www.nicefni.co.kr/">NICE에프앤아이</option>
						<option value="http://www.nicezinidata.co.kr">NICE지니데이타</option>
						<option value="http://www.nicetcm.co.kr">한국전자금융</option>
						<option value="http://www.nicevan.co.kr">NICE정보통신</option>
						<option value="http://www.kisvan.co.kr">KIS정보통신</option>
						<option value="http://www.nicecms.co.kr">NICE씨엠에스</option>
						<option value="http://www.okpos.co.kr">오케이포스</option>
						<option value="http://www.seoulset.co.kr/">서울전자통신</option>
						<option value="http://www.it-m.co.kr">아이티엠반도체</option>
						<option value="http://www.zinitix.com">지니틱스</option>
						<option value="http://www.nicelms.com">LMS</option>
						<option value="http://www.bbs.com">BBS</option>
						<option value="http://www.doctorstech.com/">닥터스텍</option>
						<option value="http://www.birdview.kr/">버드뷰</option>
					</select>
					<label for="family-link" class="label-family-link">FAMILY SITE</label>
				</div>
				<!-- //select-family-link -->
				<!-- banner-wrap 
				<div class="banner-wrap">
					<a href="https://www.nice.co.kr/ko/sustainability/jebo" target="_blank" title="새창으로 보기"><img src="${pageContext.request.contextPath}/comn/images/banner/banner-5.gif" alt="나이스 정도경영"></a>
				</div>
				-- //banner-wrap -->
				
				<!-- Isms-wrap -->
				<div class="isms-wrap" style="display: flex; align-items: flex-end; width: auto;">
					<div class="isms-logo">
						<img src="@/assets/images/common/logo-isms.png" alt="ISMS인증획득">
					</div>
					<div class="isms-text">
						<font>[인증범위]</font> 기업신용정보 서비스 등 전 사업부문<br>
						<font>[유효기간]</font> 2022년 11월 28일 ~ 2025년 11월 27일
					</div>
					<div class="ml10"><img src="@/assets/images/common/nice_logo.png"></div>
				</div>
				<!-- //Isms-wrap -->
				
				
				
			</div>
			<!-- //footer-content -->
		</div>
		<!-- //footer-container -->
		<div class="top-view-button"><a href="#top-view" title="화면상단으로 이동"><span class="glyphicon glyphicon-menu-up"></span><em>화면상단으로 이동</em></a></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			scrollTimer: 0,
			scrollY: 0,
		};
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	methods: {
		handleScroll() {
			if (this.scrollTimer) {
				return;
			}

			this.scrollTimer = setTimeout(() => {
				this.scrollY = window.scrollY;
				clearInterval(this.scrollTimer);
				this.scrollTimer = 0;
			}, 100);
		},
		toTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import './scss/footer.scss';
</style>
